// A-Team Briefing for Hotel-Edition companies (PLAN.md §5.1 item 5, Mike A7): hotels only sharpen their
// strategy, set the tone and name topics to avoid. Example posts, interests and the content mix are B2B parts
// they never see, so they are neither required nor written on this path.
import { z } from "zod";

const tone = z.number().min(0).max(100);

export const hotelBriefingSchema = z.object({
  brandVoiceTones: z.object({
    professional_casual: tone,
    direct_empathetic: tone,
    factual_emotional: tone,
    formal_conversational: tone,
  }),
  topicsToAvoid: z.array(z.string().max(100)).max(20).optional().default([]),
  topicsToAvoidOther: z.string().max(500).optional().default(""),
});

export type HotelBriefing = z.infer<typeof hotelBriefingSchema>;
